import * as React from "react";
import { Link } from "@/components/common/Link";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const faqs = [{
  question: "How are the 10% yields secured?",
  answer: "Our yields are backed by long-term (10-25 year) government-funded leases with registered Housing Associations. This provides inflation-linked, secure income with payments made directly from government-backed sources."
}, {
  question: "What is the social housing investment model?",
  answer: "It involves purchasing properties leased to registered providers who house individuals in need. The rent is essentially guaranteed by the UK government, ensuring zero void periods and no tenant management issues for the investor."
}, {
  question: "Is my capital protected?",
  answer: "Yes, all investments are asset-backed by UK bricks and mortar. You own the underlying property title, providing both high-yield income and the security of physical real estate with potential for capital appreciation."
}, {
  question: "Who handles the property management?",
  answer: "Our model is fully managed. All maintenance, tenant management, and building insurance are covered by the Housing Association under Full Repairing and Insuring (FRI) leases, meaning zero management headaches for you."
}, {
  question: "What is the minimum investment required?",
  answer: "Investment levels vary depending on the specific property portfolio and location. We recommend downloading our Investment Pack or booking a discovery call to view our current available opportunities."
}];
export default function FrequentlyAskedQuestions() {
  return <section data-section-id="96943" id="common-questions" className="bg-muted/40 py-16 md:py-24">
      <div className="container mx-auto max-w-3xl px-4 md:px-6">
        <div className="mb-12 text-center">
          <h2 className="text-secondary mb-4 text-3xl font-bold tracking-tight md:text-4xl font-default">
            Common Questions
          </h2>
          <p className="text-muted-foreground text-lg font-default">
            Everything you need to know about our government-backed property investment model and secure 10% yields.
          </p>
        </div>

        <Accordion type="single" collapsible className="w-full space-y-4">
          {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="data-[state=open]:bg-white data-[state=open]:shadow-md border-border rounded-xl border px-2 transition-all duration-200 sm:px-4">
              <AccordionTrigger className="text-secondary hover:no-underline text-left text-base font-bold sm:text-lg font-default">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground text-base leading-relaxed font-default">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>

        <div className="mt-12 text-center">
          <p className="text-foreground/80 text-base font-default">
            Still have questions?{" "}
            <Link to="https://10percent-yield.com/contact/" className="text-primary font-medium underline-offset-4 hover:underline">
              Contact our team
            </Link>
          </p>
        </div>
      </div>
    </section>;
}